<template>
  <div class="photo-album-box-1">
    <div class="photo">
      <div
        class="img"
        v-bind:style="{ 'background-image': 'url(' + imageUrl + ')' }"
      ></div>
    </div>
  </div>
</template>

<script>
import { firebaseConnection } from '../../library/firebase'
export default {
  name: 'photo-album-box-1',
  props: {
    image: null,
    type: String
  },
  data() {
    return {
      imageUrl: ''
    }
  },
  mounted() {
    this.$nextTick(this.imageLoad)
  },
  methods: {
    imageLoad() {
      return firebaseConnection
        .storage()
        .ref(this.image)
        .getDownloadURL()
        .then(url => {
          this.imageUrl = url
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.photo-album-box-1 {
  width: 240px;
  height: 321px;
  background-color: #f5f5f5;
  display: block;

  .photo {
    width: inherit;
    height: inherit;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    .img {
      width: 100%;
      height: 100%;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      transition: all 1s;
      animation: photoLoad ease-in-out;
      /*animation-delay: 1s;*/
      animation-duration: 2s;
      animation-fill-mode: forwards;
      opacity: 0;
    }

    @keyframes photoLoad {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }
  }
  &:hover {
    .photo .img {
      transform: scale(1.2);
    }
  }
}
</style>
